import axios from 'axios'

const state = {
  memberPools: [],
  ownPools: [],
  friends: [],
  poolPoints: {},
  poolInvites: [],
  poolComments: [],
  memberPoolsLoaded: true,
  ownPoolsLoaded: true,
  friendsLoaded: true,
  poolPointsLoaded: true,
}

const getters = {
  memberPools: state => state.memberPools,
  ownPools: state => state.ownPools,
  poolMembership: state => (state.memberPools.length > 0),
  poolPoints: state => state.poolPoints,
  memberPoolsLoaded: state => state.memberPoolsLoaded,
  ownPoolsLoaded: state => state.ownPoolsLoaded,
  poolPointsLoaded: state => state.poolPointsLoaded,
  friends: state => state.friends,
  friendsLoaded: state => state.friendsLoaded,
  poolComments: state => state.poolComments,
  poolInvites: state => state.poolInvites,
  numPoolInvites: state => state.poolInvites.length,
  invitesLoaded: state => state.invitesLoaded,
}

const actions = {
  getPoolInvites ({ commit }) {
    commit('INVITES_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get('/api/poolInvite', { headers: header })
    .then(response => {
      commit('POOLINVITES', response.data)
      commit('INVITES_LOADED', true)
    })
  },
  getMemberPools ({ commit }) {
    commit('MPOOLS_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get('/api/userPool/member', { headers: header })
    .then(response => {
      commit('MEMBERPOOLS', response.data)
      commit('MPOOLS_LOADED', true)
    })
  },
  getOwnPools ({ commit }) {
    commit('OPOOLS_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get('/api/userPool/owner', { headers: header })
    .then(response => {
      commit('OWNPOOLS', response.data)
      commit('OPOOLS_LOADED', true)
    })
  },
  getPoolPoints ({ commit }, poolId) {
    commit('POINTS_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get('/api/userPoolPoint/' + poolId, { headers: header })
    .then(response => {
      commit('POOLPOINTS', response.data)
      commit('POINTS_LOADED', true)
    })
  },
  getFriends ({ commit }) {
    commit('FRIENDS_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get('/api/friends', { headers: header })
    .then(response => {
      commit('FRIENDS', response.data)
      commit('FRIENDS_LOADED', true)
    })
  },
  getPoolComments ({ commit }, poolId) {
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get('/api/poolComment/' + poolId, { headers: header })
    .then(response => {
      commit('POOLCOMMENTS', response.data)
    })
  }
}

const mutations = {
  POOLINVITES(state, payload) {
    state.poolInvites = payload
  },
  INVITES_LOADED(state, payload) {
    state.invitesLoaded = payload
  },
  MEMBERPOOLS(state, payload) {
    state.memberPools = payload
  },
  MPOOLS_LOADED(state, payload) {
    state.memberPoolsLoaded = payload
  },
  OWNPOOLS(state, payload) {
    state.ownPools = payload
  },
  OPOOLS_LOADED(state, payload) {
    state.ownPoolsLoaded = payload
  },
  POOLPOINTS(state, payload) {
    state.poolPoints = payload
  },
  POINTS_LOADED(state, payload) {
    state.poolPointsLoaded = payload
  },
  FRIENDS(state, payload) {
    state.friends = payload
  },
  FRIENDS_LOADED(state , payload) {
    state.friendsLoaded = payload
  },
  POOLCOMMENTS(state, payload) {
    state.poolComments = payload
  },
}

export default {
  state, getters, actions, mutations
}
